import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
// mui
import CircularProgress from '@mui/material/CircularProgress';
// ui
import { LoaderWrapper } from './ui';
// feature loader
import { makeSelectLoader } from './selectors';
// utilities
import { theme } from '../../utilities';
//////////////////////////////////////////////////

export const Loader = ({ showLoader }) => (
  showLoader
  && (
  <LoaderWrapper data-testid='loader-wrapper'>
    <CircularProgress sx={{ color: theme.colors.lime }} />
  </LoaderWrapper>
  )
);

const mapStateToProps = state => createStructuredSelector({
  showLoader: makeSelectLoader(state),
});

export default connect(mapStateToProps, {})(Loader);
